import '../components/home/home.css'
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import HomeSection from "../components/home/home";
import Vote1 from "../components/vote/vote1";
import Vote2 from "../components/vote/vote2";
import Vote3 from "../components/vote/vote3";
import Vote4 from "../components/vote/vote4";
import Vote5 from "../components/vote/vote5";
import bg from '../assets/background.png'
import Bullets from '../components/vote/components/bullets';

function Home() {

    return (
        <>
            <div className="video-abstract-wrapper">
                <img src={bg} alt={"bg"} className="abstract-video" />
            </div>
            <Bullets />
            <div className="homeWrapper">
                <Header />
                <HomeSection />
                <Vote1 />
                <Vote2 />
                <Vote3 />
                <Vote4 />
                <Vote5 />
                <Footer />
            </div>
        </>
    )
}

export default Home